<div class="dialog">
    <h6 class="semi-bold">Profile Update</h6>
    <h6 class="bold">Request to add/update any information in the profile section?</h6>
    <div class="content" [formGroup]="requestForm">
        <textarea formControlName="change_requested" placeholder="Mention in detail the information to be updated." class="container-fluid"></textarea>
    </div>
    <!-- <div>
        <img src="assets/svg/Icon feather-paperclip.svg" alt="">&nbsp;&nbsp;<a>Add File</a>
    </div> -->
    <div class="button mt-3 row">
        <button class="white mr-2" (click)="close()">Cancel</button>
        <button class="orange ml-2" (click)="submit()">Submit</button>
    </div>
</div>